module.exports = __webpack_public_path__ + "img/merchant-support.4e614280.svg";